export let Status = /*#__PURE__*/function (Status) {
  Status["DONE"] = "done";
  Status["ERROR"] = "error";
  Status["RUNNING"] = "running";
  return Status;
}({});